import React, { useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import LocationPopup from '../ModalContentTypes/LocationPopup/LocationPopup';
import * as store from '../../hooks/useStores';
import { observer } from 'mobx-react';
import PostalCodeChangeModal from '../../components/ModalContentTypes/PostalCodeChangeModal/PostalCodeChangeModal';
import Cookies from 'js-cookie';
import { getProvinceMapping } from '../../utils/commonUtils';
import './UtilityBar.scss';

var dealerProvince = new URLSearchParams(window.location.search).get('province');
var dealerCode = new URLSearchParams(window.location.search).get('pa');
var provinceLabel = '';
if (dealerCode && dealerProvince) {
  Cookies.set('province', dealerProvince);
  Cookies.set('dealerCode', dealerCode);
  Cookies.remove('postalCode');
  const provinceMapping = getProvinceMapping();
  provinceMapping.every((province) => {
    if (province.Key === dealerProvince) {
      provinceLabel = province.Value;
      Cookies.set('provinceLabel', province.Value);
      return false;
    } else {
      return true;
    }
  });
}
function UtilityBar({ changeLabel }) {
  const { uiStore } = store.useUtilityUiStore();
  const [modalObject, setModalObject] = useState({});
  const [postalChangeModal, setPostalChangeModal] = useState(false);

  useEffect(() => {
    if (dealerCode && dealerProvince) {
      uiStore.updateLocationPopup(false);
      uiStore.updateProvinceValues(dealerProvince, provinceLabel);
    }
    if (uiStore.currentProvince) {
      const provinceMapping = getProvinceMapping();
      provinceMapping.every((province) => {
        if (province.Key === uiStore.currentProvince) {
          provinceLabel = province.Value;
          uiStore.updateProvinceValues(uiStore.currentProvince, provinceLabel);
          return false;
        } else {
          return true;
        }
      });
    }
  }, []);

  function handleChangeLocation(e) {
    e.preventDefault();
    uiStore.toogleLocationPopup();
  }
  function postalCodeChanged(modelData) {
    setModalObject(modelData);
    setPostalChangeModal(true);
  }

  return (
    <div className="utility_bar_component">
      <div className="user_location_container">
        <span className="icon-pin"></span>
        <p className="user_location">{uiStore.currentProvinceLabel}</p>
      </div>
      <a
        role="link"
        className="change_location_link"
        onClick={handleChangeLocation}
        data-testid="change_link">
        <p className="link_text">{changeLabel}</p>
        <span className="icon-chevron-right"></span>
      </a>
      <Modal
        hideCloseButton={uiStore.currentProvince === ''}
        showPopup={uiStore.showLocationPopup}
        togglePopupFn={uiStore.toogleLocationPopup}>
        <LocationPopup postalCodeChangeFunction={postalCodeChanged} />
      </Modal>
      <Modal
        hideCloseButton={false}
        showPopup={postalChangeModal}
        togglePopupFn={() => setPostalChangeModal(!postalChangeModal)}>
        <PostalCodeChangeModal modalData={modalObject} />
      </Modal>
    </div>
  );
}

export default observer(UtilityBar);
